import { useTranslation } from "react-i18next";

import Alert from "features/components/Alert";

interface ErrorProps {
  title?: string;
  content?: string | JSX.Element;
  moreInfo?: string | JSX.Element;
}

const Error = ({ title, content, moreInfo }: ErrorProps) => {
  const { t } = useTranslation("common");

  return (
    <Alert
      color="error"
      severity="error"
      data-testid="error-message"
      className=""
    >
      <div>
        <div className="font-bold mb-1">{title ?? t("error.title")}</div>
        <div>{content ?? t("error.content")}</div>
        {moreInfo && (
          <div className="text-gray-500 mt-4 inline-block text-xs">
            {moreInfo}
          </div>
        )}
      </div>
    </Alert>
  );
};

export default Error;
